import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { NotifyUser } from '../pages/pages.actions';
import { PagesState } from '../pages/pages.model';
import { callerEmail } from '../pages/pages.selectors';
import { WSSState } from '../wss/wss.model';
import { callerId, callId, lastMsg } from '../wss/wss.selectors';
import { WSSService } from '../wss/wss.service';
import { MS3Service } from './m_s3.service';
import { SetSegment, SetPlay, Play, Pause, SetCurrTime, SetSketchIndex, DelSketch, StopRec, SetSketch, DoneRecording, PlayScene, OtherRec, SetTaksIndex, SetSceneIndex, RemoteZoomOrPan, ClearTraining, GotPatients, SetUser } from './training.actions';
import { TrainingState } from './training.model';
import { delMoviesFromS3, mimeExt, mimeType, playChanged, savePlay, sceneIndex, taskIndex, user } from './training.selectors';
@Injectable({
  providedIn: 'root'
})
export class TrainingService {
  my_play: any = {}

  task_index: number = -1
  scene_index: number = -1
  patient_id: string = ""

  call_id: string | undefined
  caller_email: string | undefined
  mime_type: string = "video/webm"
  mime_ext: string = ".webm"


  constructor(
    private httpClient: HttpClient,
    public trainingStore: Store<TrainingState>,
    private wss_service: WSSService,
    private wssState: Store<WSSState>,
    public pagesState: Store<PagesState>,
    public s3_service: MS3Service,
  ) {
    console.log("Training service")



    this.pagesState.select(mimeType).subscribe((mime_type: string) => {
      this.mime_type = mime_type;
    })
    this.pagesState.select(mimeExt).subscribe((mime_ext: string) => {
      this.mime_ext = mime_ext;
    })
    this.wssState.select(callId).subscribe((call_id: string | undefined) => {
      if (this.call_id && !call_id) {
        this.trainingStore.dispatch(new ClearTraining())
      }
      this.call_id = call_id
    })
    this.wssState.select(callerEmail).subscribe(async (email: string | undefined) => {
      this.caller_email = email
      if (this.caller_email) {
        this.getUser(this.caller_email)
      }
    })

    this.trainingStore.select(playChanged).subscribe((play: any) => {
      if (play && (play.patient_id || play.name)) {
        this.my_play = play
        this.patient_id = play.patient_id

        let msg = {
          k_t: "set_play",
          play: this.my_play
        }
        this.sendMessageToOtherMembers(msg)

      }
    })
    this.trainingStore.select(taskIndex).subscribe((index: number) => {
      if (this.task_index != index) {
        this.task_index = index
        let msg = {
          k_t: "task_index",
          index: index
        }
        this.sendMessageToOtherMembers(msg)
      }
    })
    this.trainingStore.select(sceneIndex).subscribe((index: number) => {
      if (this.scene_index != index) {
        this.scene_index = index
        let msg = {
          k_t: "scene_index",
          index: index
        }
        this.sendMessageToOtherMembers(msg)
      }
    })
    this.trainingStore.select(delMoviesFromS3).subscribe((movies: any) => {
      this.delMoviesFromS3(movies)
    })

    this.trainingStore.select(savePlay).subscribe((play_to_save: any) => {
      if (play_to_save && play_to_save._id) {
        this.postPacientData(play_to_save)
      }
    })

    //**************************************************************************
    //  rep -- caller messaging
    //**************************************************************************
    //the care.component will get k_t:set_stream
    this.wssState.select(lastMsg).subscribe((msg: any) => {
      if (msg) {
        if (msg.hasOwnProperty('k_t')) {
          if (msg.from != 'rep') {
            this.gotMsgFromOrher(msg)
          }
        }
      }
    })
  }
  //****************************************************************************
  // Outgoing messages
  //****************************************************************************

  recRemTask() {
    let msg = {
      k_t: "rec_task",
    }
    this.sendMessageToOtherMembers(msg)
  }

  stopRemTask() {
    let msg = {
      k_t: "stop_task",
    }
    this.sendMessageToOtherMembers(msg)
  }
  flipRemTask() {
    let msg = {
      k_t: "flip_task",
    }
    this.sendMessageToOtherMembers(msg)
  }

  playScene(act: string, index: number) {
    let msg = {
      k_t: "play_scene",
      index: index,
      act: act
    }
    this.sendMessageToOtherMembers(msg)
    this.trainingStore.dispatch(new PlayScene(act, index))
  }
  play() {

    let msg = {
      k_t: "play",
    }
    this.sendMessageToOtherMembers(msg)
  }

  rec(roll: string) {
    let msg = {
      k_t: "rec",
      roll: roll
    }
    this.sendMessageToOtherMembers(msg)
  }

  pause() {

    let msg = {
      k_t: "pause",
    }
    this.sendMessageToOtherMembers(msg)
  }
  stopOther() {
    let msg = {
      k_t: "stop_other"
    }
    this.sendMessageToOtherMembers(msg)
  }
  stop(recS3Url: string, bIsTask: boolean, duration: number, mime_ext: string, width: number, height: number) {
    let msg = {
      k_t: "stop",
      url: recS3Url,
      is_taks: bIsTask,
      duration: duration,
      mime_ext: mime_ext,
      width: width,
      height: height
    }
    this.sendMessageToOtherMembers(msg)
  }
  sendZoomPan(msg: any) {
    this.sendMessageToOtherMembers(msg)
  }

  currTime(time: number) {
    let msg = {
      k_t: "time",
      time: time
    }
    this.sendMessageToOtherMembers(msg)
  }
  setSegment(start: number, end: number) {
    let msg = {
      k_t: "set_seg",
      start: start,
      end: end
    }
    this.sendMessageToOtherMembers(msg)
  }
  changeSketch(index: number) {
    let msg = {
      k_t: "sketch_index",
      index: index
    }
    this.sendMessageToOtherMembers(msg)
  }
  setSketch(sketch: any) {
    let msg = {
      k_t: "sketch",
      sketch: sketch,

    }
    this.sendMessageToOtherMembers(msg)

  }
  delSketch(at: number) {
    let msg = {
      k_t: "del_sketch",
      at: at
    }
    this.sendMessageToOtherMembers(msg)
  }


  sendMessageToOtherMembers(msg: any) {
    if (this.call_id) {
      let jmsg = Object.assign({}, msg)
      jmsg.from = "rep"
      this.wss_service.sendMessageToOtherMembers(jmsg)
    }
  }


  //****************************************************************************
  // Incoming messages
  //****************************************************************************

  async gotMsgFromOrher(msg: any) {
    console.log("<--  gotMsgFromOther" + JSON.stringify(msg))
    if (msg) {
      // if (msg.k_t == "go_to") {
      //   this.trainingStore.dispatch(new GoToAct(msg.act))
      // }
      // else if (msg.k_t == "scene_name") {
      //   this.trainingStore.dispatch(new SaveSceneName(msg.scene_name))
      // }      else
      if (msg.k_t == "play") {
        this.trainingStore.dispatch(new Play())
      } else if (msg.k_t == "task_index") {
        this.task_index = msg.index //to avoid sending it back
        this.trainingStore.dispatch(new SetTaksIndex(msg.index))
      } else if (msg.k_t == "scene_index") {
        this.scene_index = msg.index //to avoid sending it back
        this.trainingStore.dispatch(new SetSceneIndex(msg.index))
      } else if (msg.k_t == "play_scene") {
        this.trainingStore.dispatch(new PlayScene(msg.act, msg.index))
      } else if (msg.k_t == "pause") {
        this.trainingStore.dispatch(new Pause())
      } else if (msg.k_t == "time") {
        this.trainingStore.dispatch(new SetCurrTime(msg.time))
      } else if (msg.k_t == "sketch") {
        this.trainingStore.dispatch(new SetSketch(msg.sketch))
      } else if (msg.k_t == "sketch_index") {
        this.trainingStore.dispatch(new SetSketchIndex(msg.index))
      } else if (msg.k_t == "del_sketch") {
        this.trainingStore.dispatch(new DelSketch(msg.at))
      } else if (msg.k_t == "remote_zoom_pan") {
        this.trainingStore.dispatch(new RemoteZoomOrPan(msg))
      }
      //When the other side is recording, the care.task will show a recodng message
      else if (msg.k_t == "rec") {
        this.trainingStore.dispatch(new OtherRec())
      }
      else if (msg.k_t == "stop") {
        this.trainingStore.dispatch(new DoneRecording(msg.duration, msg.is_taks, { url: msg.url, mime_ext: msg.mime_ext, width: msg.width, height: msg.height }))
      } else if (msg.k_t == "stop_other") {
        this.trainingStore.dispatch(new StopRec())
      }
      else if (msg.k_t == "add_user") {
        this.addUser(msg.user)
      } else if (msg.k_t == "set_seg") {
        this.trainingStore.dispatch(new SetSegment(msg.start, msg.end))
      }
    }
  }

  //****************************************************************************
  // DB Interface
  //****************************************************************************
  async getPatient(patient_id: string, caller_email: string | undefined) {
    return new Promise<any>(async (resolve, reject) => {
      //get the patient and
      try {
        let url = '/patient/' + patient_id
        if (caller_email) {
          url += "/" + caller_email
        }
        let rv: any = await this.httpClient.get<any>(url).toPromise();

        if (rv.patient) {
          this.my_play = rv.patient
          this.trainingStore.dispatch(new SetPlay(rv.patient))

          resolve(rv.patient)
        }
        if (rv.error) {
          reject(rv.error)
        }
      } catch (e) {
        reject(e)
      }
    })
  }
  deletePatient(patient: any) {
    return new Promise<void>(async (resolve, reject) => {
      try {
        //Delete all the local files
        // await this.delTask(), the reducer will call delMoviesFromS3
        let patients = await this.httpClient.put<any>('/del_patient', patient).toPromise();
        if (patients) {
          if (patient) {
            this.pagesState.dispatch(new NotifyUser("Patient deleted "))
          }
          this.my_play = {}
          this.task_index = 0


          this.patient_id = ""


          if (patients) {
            this.trainingStore.dispatch(new ClearTraining())
            this.trainingStore.dispatch(new GotPatients(patients))
          }
          resolve()
        }
      } catch (e: any) {
        reject(e)
      }
    })
  }

  async getUser(email: string) {
    try {
      let url = '/user_b/' + email
      let user: any = await this.httpClient.get<any>(url).toPromise();
      this.trainingStore.dispatch(new SetUser(user))

    } catch (e) {
      console.error(e)
    }
  }

  addUser(user: any) {
    return new Promise<any>(async (resolve, reject) => {
      try {
        let user1 = Object.assign({}, user)
        if (!user1.patient_id) {
          user1.patient_id = this.patient_id
        }
        //This is because this code is the same for caller and rep
        let url = '/users_b' //For rep

        if (user1.patient_id) {
          let rv: any = await this.httpClient.post<any[]>(url, user1).toPromise();
          resolve(rv)
        } else {
          console.error("no patient_id")
          reject("no patient_id")
        }
      } catch (e: any) {
        reject(e)
      }
    })
  }
  resetPwd(email: string, name?: string, last_name?: string, company?: string) {
    return new Promise(async (resolve, reject) => {
      try {
        let body = {
          email: email.toLowerCase(),
          name: name,
          last_name: last_name,
        }
        let rv: any = await this.httpClient.post('/forgot_br', body).toPromise();

        resolve(rv)
      } catch (e: any) {
        console.error(JSON.stringify(e))
        reject(e);
      }
    })
  }


  delUser(user: any) {
    return new Promise<any>(async (resolve, reject) => {
      try {
        //This is because this code is the same for caller and rep
        let url = '/del_user_b' //For rep
        if (this.patient_id && user) {
          let rv: any = await this.httpClient.put<any[]>(url, { user: user, patient_id: this.patient_id }).toPromise();
          resolve(rv)
        } else {
          reject("no patient_id")
        }
      } catch (e: any) {
        reject(e)
      }
    })
  }
  postPacientData(play_to_save: any) {
    return new Promise<string>(async (resolve, reject) => {
      try {
        let play: any = await this.httpClient.post<any>('/patient', play_to_save).toPromise();
        if (play && play._id) {
          this.patient_id = play._id
          resolve(play._id)
        }
      } catch (e: any) {
        reject(e)
      }
    })
  }
  //****************************************************************************
  // S3 Interface
  //****************************************************************************
  delStepVideoFromS3(task: any, scene: any, act: string) {
    return new Promise<void>(async (resolve, reject) => {
      let fname
      if (scene && act && scene[act]) {
        fname = scene[act].movie_name
      }
      if (fname) {
        try {
          let key = this.my_play.patient_id + "/" + task.task_key + "/" + fname
          await this.s3_service.deleteFile(key)
        } catch (e) {
          reject(e)
        }
      }
      resolve()
    })

  }

  getVideoTrainingUrl(key: string) {
    return new Promise<any>(async (resolve, reject) => {
      try {
        //Delete all the local files
        let s3_url = await this.httpClient.put<any>('/vt_url', { key: key }).toPromise(); // /vt_url_c for client
        resolve(s3_url.url)
      } catch (e: any) {
        reject(e)
      }
    })
  }
  async delMoviesFromS3(body: any) {
    return new Promise<void>(async (resolve, reject) => {
      if (body && body.movies) {
        let keys = Object.keys(body.movies)
        if (keys.length > 0) {
          try {
            let rv: any = await this.httpClient.put<any>('/del_movies', body).toPromise();
            resolve()
            return
          } catch (e) {
            reject(e)
            return
          }
        }
      }
      resolve()
    })
  }











}
